import styled from "styled-components"
import RouterLink from "@irati/ui/src/Link/RouterLink"
import {textShadow1} from "@irati/ui/src/global/typography"

export default styled(RouterLink)`
  display: flex;
  height: 90px;
  background-image:
    linear-gradient(
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4)
    ),
    url('${(props) => props.image}');
  background-size: cover;
  background-position: center center;
  color: ${({theme}) => theme.colors.utility.white};
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  transition: transform .24s, box-shadow .24s;
  ${textShadow1}
  ${({theme}) => theme.animations.hover}

  &:hover, &:focus, &:active {
    color: ${({theme}) => theme.colors.utility.white};
  }
`
